export default {
    CASADO: 1,
}